import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassAttendanceStaff } from "./ApClassAttendanceStaff";
import type { ApClassSessionDTOBase } from "./ApClassSessionDTOBase";
import type { ApClassStaff } from "./ApClassStaff";
import type { TrackedBase } from "./TrackedBase";

export class ApClassSessionStaff implements ApClassSessionDTOBase, TrackedBase {
  constructor(public readonly sessionId: number, public readonly sessionDateTime: Date, public readonly isMakeup: string | null, public readonly cancelledDateTime: Date | null, public readonly headcount: number | null, public readonly sessionLength: number, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly instanceId: ApClassStaff | null, public readonly attendance: Array<ApClassAttendanceStaff> | null) {
    this.cbiServiceContext = null;
    this.instanceIdLoaded = this.instanceId != null;
    this.instanceIdCached = this.instanceId;
    this.attendanceLoaded = this.attendance != null;
    this.attendanceCached = this.attendance;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private instanceIdLoaded: boolean;
  private instanceIdCached: ApClassStaff | null;
  private attendanceLoaded: boolean;
  private attendanceCached: Array<ApClassAttendanceStaff> | null;
  async instanceIdLazy(): Promise<ApClassStaff> {
    if (!this.instanceIdLoaded) {
      this.instanceIdCached = await this.cbiServiceContext!.apClassService().getApClassSessionStaffInstanceId(this.sessionId);
      this.instanceIdLoaded = true;
    }
    return this.instanceIdCached!;
  }
  async attendanceLazy(): Promise<Array<ApClassAttendanceStaff>> {
    if (!this.attendanceLoaded) {
      this.attendanceCached = await this.cbiServiceContext!.apClassService().getApClassSessionStaffAttendance(this.sessionId);
      this.attendanceLoaded = true;
    }
    return this.attendanceCached!;
  }
}
